/**
 * SerialNumber
 * @author ftgibran
 */
import {ID, TAG} from 'simpli-web-sdk'

export default class CodigoBarra {
  readonly $name: string = 'SerialNumber'

  get $id() {
    return this.idCodigoBarraPk
  }
  set $id(val: ID) {
    this.idCodigoBarraPk = val
  }
  get $tag() {
    return this.codigo || ''
  }
  set $tag(val: TAG) {
    this.codigo = val
  }

  idCodigoBarraPk: ID = 0

  codigo: string | null = null

  ativo: boolean | null = null

  idTipoCodigoBarra: number = 0
}
